module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-2-A.2663650a.svg";